import mission from "../assets/about/mission.webm";
import vision from "../assets/about/vision.webm";
import { FaGlobe, FaLightbulb, FaUsers } from 'react-icons/fa';
import { MdVerifiedUser, MdThumbUp } from 'react-icons/md';

import {
    FiBriefcase,
    FiGlobe,
    FiHome,
    FiTrendingUp,
    FiKey,
    FiUserCheck,
    FiArrowUpRight,
    FiTruck
} from 'react-icons/fi';
import { FaRegBuilding } from "react-icons/fa";
import person from "../assets/person.jpeg"
import sofia from "../assets/testi/Sofia.png"
import john from "../assets/testi/john.png"
import maya from "../assets/testi/maya.png"
import marcus from "../assets/user/u1.jpg"
import Galan from "../assets/user/u2.jpg";
import Smith from "../assets/user/u3.jpg";

export const servicesData = [
    {
        id: 0,
        title: "Import/Export Services",
        link: "/services/import-export-services",
        description: "Streamlined solutions for navigating global trade complexities.",
        icon: <FiBriefcase className="w-6 h-6" />,
    },
    {
        id: 1,
        title: "Migration Services",
        link: "/services/migration-services",
        description: "Expert guidance for smooth international relocation processes.",
        icon: <FiGlobe className="w-6 h-6" />,
    },
    {
        id: 2,
        title: "Residency by Investment",
        link: "/services/residency-by-investment",
        description: "Secure your permanent residency through strategic investment options.",
        icon: <FiHome className="w-6 h-6" />,
    },
    {
        id: 3,
        title: "Business Buy/Sell",
        link: "/services/business-buy-sale-services",
        description: "Seamless support for buying or selling businesses with expert evaluation.",
        icon: <FiTrendingUp className="w-6 h-6" />,
    },
    {
        id: 4,
        title: "Real Estate Assistance",
        link: "/services/real-estate",
        description: "Your trusted partner in finding and securing optimal property deals.",
        icon: <FiKey className="w-6 h-6" />,
    },
    {
        id: 5,
        title: "Consulting Services",
        link: "/services/consulting-services",
        description: "Strategic advice for your business, legal, and migration requirements.",
        icon: <FiUserCheck className="w-6 h-6" />,
    },
    {
        id: 6,
        title: "Work Abroad",
        link: "/services/work-abroad",
        description: "Unlock global career opportunities with comprehensive visa and placement support.",
        icon: <FiArrowUpRight className="w-6 h-6" />,
    },
    {
        id: 7,
        title: "Property Management",
        link: "/services/property-management-services-in-india",
        description: "Professional and reliable management for your residential and commercial properties.",
        icon: <FaRegBuilding className="w-6 h-6" />,
    },
    {
        id: 8,
        title: "Relocation Support",
        link: "/services/relocation-in-india",
        description: "Stress-free relocation services for individuals, families, and businesses.",
        icon: <FiTruck className="w-6 h-6" />,
    },

    {
        id: 9,
        title: "Medical Tourism",
        link: "/services/medical-tourism-services",
        description: "Access world-class healthcare at affordable prices. Expert guidance for medical tourism including treatment planning, hospital selection, travel arrangements, and post-care support.",
        icon: <FiTruck className="w-6 h-6" />,
    },
];


export const contentMap = {
    mission: {
        title: 'Our Mission',
        text: 'Our central mission is to act as a catalyst for global success, empowering both individual professionals and burgeoning businesses to confidently and effectively navigate the complexities of the international landscape. We achieve this by delivering expert guidance that is both insightful and practical, offering personalized solutions meticulously tailored to the unique aspirations and challenges of each client. Furthermore, we are committed to ensuring seamless execution across all international borders, providing the support and resources necessary to transform ambitious goals into tangible realities in the global marketplace. We strive to be the trusted partner that unlocks worldwide opportunities, fostering growth and enabling our clients to thrive in an interconnected world.',
        image: mission,
    },
    vision: {
        title: 'Our Vision',
        text: 'Our overarching vision is to establish ourselves as the preeminent and trusted global partner for individuals and organizations aspiring to broaden their horizons and venture into the international arena. We aim to be the preferred choice for anyone seeking to navigate the complexities and capitalize on the vast potential of the global marketplace. By consistently providing exceptional guidance, fostering enduring relationships built on trust and expertise, and demonstrating a deep understanding of international dynamics, we strive to be the first name that comes to mind for those embarking on their international expansion journey. Our commitment is to empower our clients to achieve their global ambitions with confidence and success, solidifying our position as the leading partner in their international growth. ',
        image: vision,
    },
};

export const coreValues = [
    { name: 'Integrity', description: 'We operate with complete transparency and ethical standards.', icon: MdVerifiedUser },
    { name: 'Excellence', description: 'We strive for exceptional quality in every service we provide.', icon: MdThumbUp },
    { name: 'Client-Centricity', description: 'We tailor our solutions to each client\'s unique needs and aspirations.', icon: FaUsers },
    { name: 'Global Perspective', description: 'We leverage our international network and cross-cultural understanding.', icon: FaGlobe },
    { name: 'Innovation', description: 'We continuously evolve our approaches to deliver optimal results.', icon: FaLightbulb },
];


export const navbarContent = [
    {
        key: "import_export",
        title: "Import/Export Services",
        url: "/services/import-export-services",

    },
    {
        key: "migration_services",
        title: "Migration Services",
        url: "/services/migration-services",


    },
    {
        key: "residency_by_investment",
        url: "/services/residency-by-investment",
        title: "Residency by Investment",


    },
    {
        key: "business_sell",
        url: "/services/business-buy-sale-services",
        title: "Business Buy/Sell ",


    },
    {
        key: "real_estate",
        url: "/services/real-estate",
        title: "Real Estate Assistance",

    },
    {
        key: "consulting_services",
        url: "/services/consulting-services",
        title: "Consulting Services",


    },
    {
        key: "work_aboard",
        url: "/services/work-abroad",
        title: "Work Abroad",


    },
    {
        key: "property_management",
        url: "/services/property-management-services-in-india",
        title: "Property Management",


    },
    {
        key: "relocation_support",
        url: "/services/relocation-in-india",
        title: "Relocation Support",
    },
    {
        key: "medical_tourism",
        url: "/services/medical-tourism-services",
        title: "Medical Tourism",
    },
];


export const testimonialsData = [
    {
        quote: "We've just had our first completely 100% positive satisfaction survey for relocators to Spain. PG Overseas have absolutely upgraded our relocation experience in Spain and we loved working with the whole team.",
        name: "Marcus",
        title: "People Operations Lead (Mobility)",
        company: "Personio",
        logo: "/images/personio-logo.png",
        image: marcus,
    },
    {
        quote: "\"Working with PG Overseas has been a great experience, they have been really supportive in many aspects such as working permits and relocation services! ",
        name: "Manuela Galan",
        title: "People Operations Specialist",
        company: "TravelPerk",
        logo: "/images/travelperk-logo.png",
        image: Galan,
    },
    {
        quote: "\"Best service ever! They made the impossible possible for our new hires. Thank you, PG Overseas team!\"",
        name: "Sofia Rodriguez",
        title: "HR Manager",
        company: "GloboTech",
        logo: "/images/globotech-logo.png",
        image: sofia,
    },
    {
        quote: "Another fantastic experience with their global services...",
        name: "John Doe",
        title: "CEO",
        company: "Acme Corp",
        logo: "/images/acme-logo.png",
        image: john,
    },
    {
        quote: "Their personalized approach made all the difference...",
        name: "Jane Smith",
        title: "Marketing Director",
        company: "Beta Industries",
        logo: "/images/beta-logo.png",
        image: Smith,
    },
];


export const testimonialsDataNew = [
    {
        quote: "We've just had our first completely 100% positive satisfaction survey for relocators to Spain. PG Overseas have absolutely upgraded our relocation experience in Spain and we loved working with the whole team.",
        name: "Maya Procter",
        title: "People Operations Lead (Mobility)",
        company: "Personio",
        logo: "/images/personio-logo.png",
        image: maya,
    },
    {
        quote: "\"Working with PG Overseas has been a great experience, they have been really supportive in many aspects such as working permits and relocation services! ",
        name: "Manuela Galan",
        title: "People Operations Specialist",
        company: "TravelPerk",
        logo: "/images/travelperk-logo.png",
        image: Galan,
    },
    {
        quote: "\"Best service ever! They made the impossible possible for our new hires. Thank you team!\"",
        name: "Sofia Rodriguez",
        title: "HR Manager",
        company: "GloboTech",
        logo: "/images/globotech-logo.png",
        image: sofia,
    },
    {
        quote: "Another fantastic experience with their global services.",
        name: "John Doe",
        title: "CEO",
        company: "Acme Corp",
        logo: "/images/acme-logo.png",
        image: john,
    },
    {
        quote: "Their personalized approach made all the difference.",
        name: "Jane Smith",
        title: "Marketing Director",
        company: "Beta Industries",
        logo: "/images/beta-logo.png",
        image: person,
    },
    {
        quote: "Their personalized approach made all the difference...",
        name: "Jane Smith",
        title: "Marketing Director",
        company: "Beta Industries",
        logo: "/images/beta-logo.png",
        image: person,
    },


];

export const faqData = [
    {
        question: 'What services does PG Overseas offer?',
        answer:
            'PG Overseas Services Private Limited provides expert cross-border services, simplifying the complexities of the international landscape for individuals and businesses worldwide. Our services include [mention specific services like visa assistance, immigration consulting, global mobility solutions, etc.].',
    },
    {
        question: 'Where is PG Overseas located?',
        answer:
            'Our headquarters are strategically located in Gujarat, India.',
    },
    {
        question: 'Who does PG Overseas help?',
        answer:
            'We serve both individual professionals looking for international opportunities and diverse businesses aiming to expand their global reach.',
    },
    {
        question: 'How can PG Overseas simplify international ventures?',
        answer:
            'We offer a comprehensive suite of expert cross-border services meticulously designed to demystify the often-intricate processes involved in global ventures. Our commitment is to simplify these complexities, empowering our clients to navigate the international landscape with enhanced confidence and ease.',
    },
    {
        question: 'How do I learn more about PG Overseas’s services?',
        answer:
            'You can explore the detailed information about our services on our website or contact our team directly for personalized assistance.',
    },
    {
        question: 'Does PG Overseas have any global partners?',
        answer:
            'Yes, PG Overseas collaborates with a network of partners across international borders to provide comprehensive support to our clients.',
    },
    {
        question: 'How can I contact PG Overseas?',
        answer:
            'You can find our contact information, including phone numbers and email addresses, on our website’s contact page.',
    },
];